<template>
  <div>
    <div class="homeDoctorvideo" v-if="$store.state.webNavigator=='pc'">
      <div class="home-doctorvideo marginAuto max1720">
        <div>
          <div class="flexSpace">
            <p class="part-title list-tlt displayIB">
              减肥视频
              <span class="list-tlt-tip">-</span>
              专家教你健康瘦身
            </p>
            <div class="goto displayIB">
              <vue-link :to="{path:'/encyclopeDias/'+urlType+'-0-1-'+urlName+'.html'}">
                <img class="more-icon"
                     src="https://jusewebapp.zmelo.com/zml-gw/pc_home/goto.png"
                     alt="" title="" ></vue-link>
            </div>
          </div>
          <div class="doctorvideo-list">
            <div class="displayIB positionRE doctorvideo-bar pointEr"
                 :class="(index+1)%3==0?'doctorvideo-last-bar':''"
                 v-for="(item , index) in videolist"
                 :key="index"
                 @click="playVideo(item.videoUrl,item.title)">
              <img class="doctorvideo-backimg" :src="myFun(item.coverImg)?myFun(item.coverImg):''" :alt="item.title" title="">
              <img class="video-start positionAB video-min-start"
                   src="https://jusewebapp.zmelo.com/zml-gw/pc_home/startmin.png" alt="" title="">
              <p class="col444444 doctorvideo-Tlt overflowText">{{item.title}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="phone-page">
      <div class="PhoneHome-title">减肥视频 <span class="col00CDA2">-</span> <br> 专家教你健康瘦身</div>
      <div class="video-list flexStart">
        <div class="displayIB pointEr doctorvideo-last-bar"
             v-for="(item , index) in videolist"
             :key="index"
             @click="playVideo(item.videoUrl,item.title)">
          <div class="doctorvideo-bar positionRE">
            <img class="doctorvideo-backimg" :src="httptype(item.coverImg)" :alt="item.title" title="">
            <img class="video-start positionAB video-min-start"
                 src="https://jusewebapp.zmelo.com/zml-gw/pc_home/startmin.png" alt="" title="">
          </div>
          <p class="doctorvideo-Tlt firstText overflowText">{{item.title}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {$get, $post, } from '@/others/ajax';
import config from '@/others/interface';
import {myFun} from "../../../../plug/modifyImagePath"

export default {
  name: 'homeDoctorvideo',
  props: {
    loadType: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      imgUrl: 'https://jusexcx.oss-cn-hangzhou.aliyuncs.com/',
      videolist: [],
      urlType: '',
      urlName: '',
    };
  },
  methods: {
    // 获取类型
    async getType () {
      let res = await $get(config.zmlgw + '/web/getClass?code=A8');// 视频列表接口1
      if (res.code == 200) {
        this.urlType = res.data[0].id;
        this.urlName = pinyinUtil.getPinyin(res.data[0].text, '', false, false);
      }
    },
    httptype (url) { // 图片判断
      if (url) {
        url.toString();
        if (url.indexOf('http') == '-1') {
          return myFun(this.imgUrl + url);
        } else {
          return myFun(url);
        }
      }
      return '';
    },
    myFun(a) {
        if(a instanceof Array){
            var array = [];
            a.map(item => {
                if(item.indexOf('jusewebapp.oss-cn-hangzhou.aliyuncs.com') != -1){
                    var index = item.indexOf('jusewebapp.oss-cn-hangzhou.aliyuncs.com');
                    var items = item.substring(0, index) + "jusewebapp.zmelo.com" + item.substring(index + 39);
                    array.push(items)
                }else{
                    var index = item.indexOf('jusexcx.oss-cn-hangzhou.aliyuncs.com');
                    item = item.substring(0, index) +  "jusexcx.zmelo.com" + a.substring(index + 36);
                    array.push(items)
                }
            })
            return array;
        }else{
            if (a.indexOf('jusewebapp.oss-cn-hangzhou.aliyuncs.com') != -1) {
                var index = a.indexOf('jusewebapp.oss-cn-hangzhou.aliyuncs.com');
                return a.substring(0, index) + "jusewebapp.zmelo.com" + a.substring(index + 39);
            }
            if (a.indexOf('jusexcx.oss-cn-hangzhou.aliyuncs.com') != -1) {
                var index = a.indexOf('jusexcx.oss-cn-hangzhou.aliyuncs.com');
                return a.substring(0, index) +  "jusexcx.zmelo.com" + a.substring(index + 36)
            }
        }
    },
    goMore () {
      this.$router.push({path: '/encyclopeDias/' + this.urlType + '/0/1/' + this.urlName + '.html', });
    }, // 查看更多
    async getVideo () {
      let res = await $get(config.zmlgw + '/web/getVideoHomeList?code=A8&pageSize=6');// 视频列表接口1
      if (res.code == 200) {
        this.videolist = res.data;
      }
    },
    playVideo (url, tlt) {
      this.$emit('playVideo2', url, tlt);
    },
  },
  mounted () {
    this.getVideo();
    this.getType();
  },
};
</script>

<style lang="less" scoped>
  @import url('../../../../../static/css/fontSize.less');

  @media screen and (max-width: 800px) {
    .phone-page {
      padding: 66*@width1 0 0;
      background: #fff;
    }

    .PhoneHome-title {
      margin-bottom: 39*@width1;
    }

    .part-info {
      text-align: center;
      color: #666;
      font-size: 24*@width1;
      margin-bottom: 21*@width1;
    }

    .video-list {
      flex-wrap: wrap;
      margin-bottom: 25*@width1;
    }

    .doctorvideo-last-bar {
      width: 326*@width1;
      margin-bottom: 35*@width1;
    }

    .doctorvideo-last-bar:nth-child(2n) {
      margin-left: 35*@width1;
    }

    .doctorvideo-bar, .doctorvideo-backimg {
      width: 326*@width1;
      height: 183*@width1;
    }

    .doctorvideo-bar {
      margin-right: 33*@width;
      margin-bottom: 35*@width1;
    }

    .doctorvideo-Tlt {
      font-size: 24*@width1;
      color: #333;
      margin-top: 19*@width;
    }

    .video-start {
      width: 31*@width1;
      height: 31*@width1;
      left: 50%;
      top: 45%;
      transform: translate(-50%, -50%);
    }

    .more-btn {
      margin: 0 auto;
      width: 163.9*@width1;
      height: 46.9*@width1;
      background: #fff;
      border: solid 1px #B5B5B5;
      border-radius: (46.9/2)*@width1;
    }

    .more-btn-text {
      font-size: 19*@width1;
      color: #333;
    }
  }

  @media screen and (min-width: 800px) {
    .part-title {
      margin-bottom: 20*@width;
    }

    .homeDoctorvideo {
      margin-top: 45*@width;
    }

    .doctorvideo-bar, .doctorvideo-backimg {
      width: 219.5*@width !important;
      height: 123*@width;
    }

    .doctorvideo-bar {
      margin-right: 20.5*@width;
    }

    .doctorvideo-last-bar {
      margin-right: 0;
    }

    .doctorvideo-Tlt {
      font-size: 11*@width;
      line-height: 30*@width;
      margin-bottom: 12*@width;
    }

    .video-start {
      left: 50%;
      top: 45%;
      transform: translate(-50%, -50%);
    }
  }
</style>



// WEBPACK FOOTER //
// homeDoctorvideo.vue